import {Injectable, Injector} from '@angular/core';
import {Actions, createEffect, ofType} from '@ngrx/effects';
import {of} from 'rxjs';
import {catchError, map, mergeMap} from 'rxjs/operators';

import * as ac from './actions.query.checkliste-lese-rollen-admin';
import * as api from '../../../clients/veranstaltungen';

@Injectable()
export class VeranstaltungenChecklisteLeseRollenAdminEffects {

    ChecklisteLeseRollenAdmin$ = createEffect(() => this.actions$.pipe(
        ofType(ac.GET_CHECKLISTE_LESE_ROLLEN_ADMIN),
        mergeMap((x: ac.GetChecklisteLeseRollenAdminAction) => {
            const optPayload = (x !== undefined && x !== null && x.optPayload !== undefined) ? x.optPayload : null;
            return this.getService().getChecklisteLeseRollenAdmin(x.checkliste_id).pipe(
                map((result: any) => {
                    return new ac.GetChecklisteLeseRollenAdminErfolgreichAction(result, x.checkliste_id, optPayload);
                }),
                catchError((error: any) => {
                    const nextAction = new ac.GetChecklisteLeseRollenAdminFehlerAction(error, x.checkliste_id, optPayload);
                    return of(nextAction);
                })
            );
        })
    ));

    private service: api.AdminQueryService = null;

    constructor(private actions$: Actions, private injector: Injector) {
    }

    private getService(): api.AdminQueryService {
        if (this.service === null) {
            this.service = this.injector.get(api.AdminQueryService);
        }
        return this.service;
    }
}
